import { useQuery as c } from "@tanstack/vue-query";
import { computed as i, toValue as n } from "vue";
const o = ["creative-group"], l = {
  all: o,
  byCampaign: (e) => [...o, "campaign", e],
  list: (e) => [...o, "campaign", e, "list"],
  detail: (e, r) => [...o, "campaign", e, "detail", r]
}, G = (e, r, t) => {
  const s = i(() => l.list(n(r).campaignId));
  return c({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const a = n(r);
      return e.creativeGroup.findAll({ campaignId: a.campaignId });
    }
  });
}, I = (e, r, t) => {
  const s = i(() => {
    const a = n(r);
    return l.detail(a.campaignId, a.creativeGroupId);
  });
  return c({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const a = n(r);
      return e.creativeGroup.findOne({ creativeGroupId: a.creativeGroupId });
    }
  });
}, q = async (e, r, t) => {
  await e.prefetchQuery({
    queryKey: l.list(t.campaignId),
    queryFn: async () => r.creativeGroup.findAll(t)
  });
}, K = async (e, r, t) => {
  await e.prefetchQuery({
    queryKey: l.detail(t.campaignId, t.creativeGroupId),
    queryFn: async () => r.creativeGroup.findOne({ creativeGroupId: t.creativeGroupId })
  });
}, y = ["creative"], u = ["landing"], p = {
  all: y,
  list: (e) => [...y, "list", e]
}, d = {
  all: u,
  list: (e) => [...u, "list", e]
}, m = {
  all: [...u, "group"],
  list: (e) => [...u, "group", "list", e]
}, f = (e, r, t) => {
  const s = i(() => p.list(n(r)));
  return c({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const a = n(r);
      return e.creatives.list(a);
    }
  });
}, A = (e, r, t) => {
  const s = i(() => d.list(n(r)));
  return c({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const a = n(r);
      return e.landings.list(a);
    }
  });
}, C = (e, r, t) => {
  const s = i(() => m.list(n(r)));
  return c({
    ...t,
    queryKey: s,
    queryFn: async () => {
      const a = n(r);
      return e.landingGroups.list(a);
    }
  });
};
export {
  l as creativeGroupKeys,
  p as creativeKeys,
  m as landingGroupKeys,
  d as landingKeys,
  K as prefetchCreativeGroup,
  q as prefetchCreativeGroupList,
  I as useCreativeGroup,
  G as useCreativeGroupList,
  f as useCreativeList,
  C as useLandingGroupList,
  A as useLandingList
};
//# sourceMappingURL=queries.js.map
